// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const fetchPromise = <T extends unknown>(url: string, options: RequestInit): Promise<T> => {
  return new Promise((resolve, reject) => {
    fetch(url, { ...options, credentials: 'same-origin' })
      .then((response) => response.text())
      .then((text) => (text ? JSON.parse(text) : null))
      .then((data: T) => resolve(data))
      .catch((err) => reject(err));
  });
};
